import React from 'react';

import CasinoIcon from '@swf/core/assets/casino.svg';
import ChallengesIcon from '@swf/core/assets/challenges.svg';
import CreditCardIcon from '@swf/core/assets/icons/alternates/credit-card.svg';
import PhoneIcon from '@swf/core/assets/icons/alternates/phone.svg';
import StarsRewardsIcon from '@swf/core/assets/icons/alternates/stars-rewards.svg';
import Arrow from '@swf/core/assets/icons/arrow.svg';
import FacebookIcon from '@swf/core/assets/icons/facebook.svg';
import InstagramIcon from '@swf/core/assets/icons/instagram.svg';
import Language from '@swf/core/assets/icons/language.svg';
import StoreIcon from '@swf/core/assets/icons/store.svg';
import TwitchIcon from '@swf/core/assets/icons/twitch-social-icon.svg';
import TwitterXIcon from '@swf/core/assets/icons/twitter-x.svg';
import TwitterIcon from '@swf/core/assets/icons/twitter.svg';
import YoutubeIcon from '@swf/core/assets/icons/youtube.svg';
import PokerIcon from '@swf/core/assets/poker.svg';
import BrandMerchIcon from '@swf/core/assets/sideMenu/brand-merch.svg';
import DailySpinIcon from '@swf/core/assets/sideMenu/daily-spin.svg';
import HelpIcon from '@swf/core/assets/sideMenu/help.svg';
import HomeIcon from '@swf/core/assets/sideMenu/home.svg';
import LeaderBoardIcon from '@swf/core/assets/sideMenu/leader-board.svg';
import PromotionsIcon from '@swf/core/assets/sideMenu/promotions.svg';
import SettingsIcon from '@swf/core/assets/sideMenu/settings.svg';
import StarIcon from '@swf/core/assets/sideMenu/star.svg';
import ToolsIcon from '@swf/core/assets/sideMenu/tools.svg';
import TournamentTicketIcon from '@swf/core/assets/sideMenu/tournament-ticket.svg';
import SportsIcon from '@swf/core/assets/sports.svg';

interface Props {
  icon?: string;
  className?: string;
}

const Icon: React.FC<Props> = ({ icon, className }) => {
  switch (icon) {
    case 'creditcard':
      return <CreditCardIcon className={className} />;
    case 'phone':
      return <PhoneIcon className={className} />;
    case 'starsrewards':
    case 'rewards':
      return <StarsRewardsIcon className={className} />;
    case 'promotions':
      return <PromotionsIcon className={className} />;
    case 'poker':
      return <PokerIcon className={className} />;
    case 'casino':
      return <CasinoIcon className={className} />;
    case 'challenges':
      return <ChallengesIcon className={className} />;
    case 'sports':
      return <SportsIcon className={className} />;
    case 'arrow':
      return <Arrow className={className} />;
    case 'language':
      return <Language className={className} />;
    case 'store':
      return <StoreIcon className={className} />;
    case 'facebook':
      return <FacebookIcon className={className} />;
    case 'twitter':
      return <TwitterIcon className={className} />;
    case 'youtube':
      return <YoutubeIcon className={className} />;
    case 'twitch':
      return <TwitchIcon className={className} />;
    case 'instagram':
      return <InstagramIcon className={className} />;
    case 'twitter-x':
      return <TwitterXIcon className={className} />;
    case 'home':
      return <HomeIcon className={className} />;
    case 'star':
      return <StarIcon className={className} />;
    case 'leaderboard':
      return <LeaderBoardIcon className={className} />;
    case 'tournamentticket':
      return <TournamentTicketIcon className={className} />;
    case 'brandmerch':
      return <BrandMerchIcon className={className} />;
    case 'dailyspin':
      return <DailySpinIcon className={className} />;
    case 'tools':
      return <ToolsIcon className={className} />;
    case 'help':
      return <HelpIcon className={className} />;
    case 'settings':
      return <SettingsIcon className={className} />;
    default:
      return null;
  }
};

export default Icon;
